import { render } from "./ImageCropper.vue?vue&type=template&id=5c897c24&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=5c897c24&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c897c24"]])

export default __exports__